/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Surcharge } from './Surcharge';
import {
    SurchargeFromJSON,
    SurchargeFromJSONTyped,
    SurchargeToJSON,
    SurchargeToJSONTyped,
} from './Surcharge';

/**
 * 
 * @export
 * @interface Pricing
 */
export interface Pricing {
    /**
     * The price in euro
     * @type {number}
     * @memberof Pricing
     */
    amount?: number;
    /**
     * List of surcharges
     * @type {Array<Surcharge>}
     * @memberof Pricing
     */
    surcharges?: Array<Surcharge>;
}

/**
 * Check if a given object implements the Pricing interface.
 */
export function instanceOfPricing(value: object): value is Pricing {
    return true;
}

export function PricingFromJSON(json: any): Pricing {
    return PricingFromJSONTyped(json, false);
}

export function PricingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pricing {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'surcharges': json['surcharges'] == null ? undefined : ((json['surcharges'] as Array<any>).map(SurchargeFromJSON)),
    };
}

export function PricingToJSON(json: any): Pricing {
    return PricingToJSONTyped(json, false);
}

export function PricingToJSONTyped(value?: Pricing | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'surcharges': value['surcharges'] == null ? undefined : ((value['surcharges'] as Array<any>).map(SurchargeToJSON)),
    };
}

